// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Modal} from '../../lib/modal';
import {Button} from '../../lib/button';
import {SA2025_EXPIRATION_DATE} from './use_sa2025';

import styles from './styles.module.less';

interface i_settlement_popup_props {
    is_open: boolean;
    on_close: ()=>void;
    on_receive_benefit: ()=>void;
    is_client: boolean;
    benefit_type?: string;
    benefit_value?: number;
}

export const Settlement_popup = (props: i_settlement_popup_props)=>{
    const {is_open, on_close, on_receive_benefit, is_client, benefit_type,
        benefit_value} = props;
    if (!is_client)
        return null;
    const get_benefit_text = ()=>{
        if (benefit_type=='refund')
            return 'a refund of 3 NIS';
        const days = benefit_value || 7;
        return `${days} days of free usage of the Hola Watch Time package`;
    };
    return <Modal is_open={is_open} on_close={on_close}
      paddingless no_logo width={468}>
      <div className={cn(styles.sa2025_popup)}>
        <div className={cn(styles.content_section)}>
          <div className={cn(styles.title_and_content)}>
            <div className={cn(styles.title)}>
              Dear Hola user,
            </div>
            <div className={cn(styles.content)}>
              Subject to a declaration that you were a user of Hola
              services during the period from January 2015 until 23 July
              2025, or during any part of this term, you will be entitled
              to {get_benefit_text()}, subject to and in accordance with
              this benefit's terms on the Hola website, and in accordance
              with the class action settlement in CA (Dist. - TA)
              62567-02-22. (This benefit is valid until
              {' '}{SA2025_EXPIRATION_DATE})
            </div>
            <div className={styles.button_wrapper}>
              <Button caption={'Receive the benefit'}
                size="md" round on_click={on_receive_benefit}
                cls={styles.button}/>
            </div>
          </div>
          <div className={cn(styles.footer)}>
            This message is being published in accordance with the
            confirmation of the Tel Aviv District Court of 23 July 2025
          </div>
        </div>
      </div>
    </Modal>;
};
